import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { ONGOING_IDO, PAST_IDO, UPCOMING_IDO } from './common_components/constants';
import {
  NFTDetailsScreen,
  OngoingIDO,
  OngoingNFT,
  PastIDO,
  PastNFT,
  TokenDetails,
  UpcommingIDO,
  UpcommingNFT,
  Disclaimer
} from './pages';

export const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<OngoingIDO />}></Route>
      <Route path="/homeScreen" element={<OngoingIDO />}></Route>
      <Route path="/nftDetails" element={<NFTDetailsScreen />}></Route>
      <Route path="/upcoming-ido" element={<UpcommingIDO />}></Route>
      <Route path="/ongoing-ido" element={<OngoingIDO />}></Route>
      <Route path="/past-ido" element={<PastIDO />}></Route>
      <Route path="/upcoming-nft" element={<UpcommingNFT />}></Route>
      <Route path="/ongoing-nft" element={<OngoingNFT />}></Route>
      <Route path="/past-nft" element={<PastNFT />}></Route>
      <Route path="/nftDetails/*" element={<NFTDetailsScreen />}></Route>
      <Route path="/tokendetails/*" element={<TokenDetails />}></Route>
      <Route path="/disclaimer/*" element={<Disclaimer />}></Route>
    </Routes>
  );
};

export const tabRoutes = {
  ido: [
    {
      label: ONGOING_IDO,
      to: '/ongoing-ido',
      value: '/ongoing-ido'
    },
    {
      label: UPCOMING_IDO,
      to: '/upcoming-ido',
      value: '/upcoming-ido'
    },
    {
      label: PAST_IDO,
      to: '/past-ido',
      value: '/past-ido'
    }
  ],
  nft: [
    {
      label: ONGOING_IDO,
      to: '/ongoing-nft',
      value: '/ongoing-nft'
    },
    {
      label: UPCOMING_IDO,
      to: '/upcoming-nft',
      value: '/upcoming-nft'
    },
    {
      label: PAST_IDO,
      to: '/past-nft',
      value: '/past-nft'
    }
  ]
};
